import { useState } from 'react'
import { useGeneralSettings } from '../../hooks/useGeneralSettings'

/**
 * Navbar brand mark. When the admin has set a company_logo in
 * GET /general-settings, that image replaces ONLY the mark (the ॐ roundel /
 * zodiac disc) — the wordmark beside it lives in the call site and always
 * renders. `className` sets the height/max-width plus any backdrop per call
 * site: call sites on dark surfaces add a white pill behind the image so a
 * dark-ink logo stays legible (headers toggle it off once the navbar scrolls
 * to solid white; the dark mobile drawers keep it always). Otherwise — while
 * settings load, when the field is empty, or if the image URL fails to load —
 * the original hard-coded mark passed as `children` renders.
 */
export default function BrandLogo({ className = 'h-10 w-auto sm:h-12', children }) {
  const { settings } = useGeneralSettings()
  const [imageFailed, setImageFailed] = useState(false)
  const logo = typeof settings.company_logo === 'string' ? settings.company_logo.trim() : ''
  const name = typeof settings.company_name === 'string' && settings.company_name.trim() ? settings.company_name.trim() : 'Astrologer Raju'

  if (logo && !imageFailed) {
    return (
      <img
        src={logo}
        alt={name}
        onError={() => setImageFailed(true)}
        className={`${className} object-contain shrink-0`}
      />
    )
  }
  return children ?? null
}
